// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { debounce } from "lodash";
import { Toastr, Button } from "@revvsales/components";
// Components Imports
import { ReactSelect, SearchableSelect } from "../../../../../commonComponents";

// Action Imports
import { AssetActions, UserActions } from "../../../../../actions";

import { GlobalUtils } from "../../../../../utils";

// Destructuring
const { assetCollaboratorsAccessAction } = AssetActions;
const { readDataFromLocalStorage } = GlobalUtils;
const { loadOwnerData } = UserActions;
const accessLevels = ["View", "Edit"];

// Decalaration
const DEBOUNCE_WAIT_TIME = 300;

class AssetInviteSection extends Component {
  state = {
    shareWith: [],
    showSelector: true,
    showBtnLoader: false,
    users: [],
  };

  _updateShareAccess = (person, access) => {
    const data = [...this.state.shareWith];
    const index = data.findIndex(item => item.name === person);

    if (index >= 0) {
      data[index].currentAccess = access;
      this.setState({ shareWith: data });
    }
  };

  _handleChangeInSelect = value => {
    const person = {
      id: value.id,
      name: value.name,
      currentAccess: "View",
    };
    this.setState(prevState => ({
      shareWith: [...prevState.shareWith, person],
      showSelector: false,
    }));
  };

  _removeSelectedUser = id => {
    if (id === null) {
      this.setState({ showSelector: false });
    } else {
      const shareList = [...this.state.shareWith];
      const newShareList = shareList.filter(item => item.id !== id);
      if (newShareList.length === 0) {
        this.setState({ showSelector: true });
      }
      this.setState({ shareWith: newShareList });
    }
  };

  _getOptions = async (inputValue, callback) => {
    if (inputValue) {
      let result = [];
      await loadOwnerData(inputValue).then(data => {
        result = data.users;
      });
      this.setState({ users: result }, () => {
        const filteredOptions = this._filterUsersForOptions(this.state.users);
        return callback(filteredOptions);
      });
    }

    return callback([]);
  };

  _filterUsersForOptions = users => {
    let result = [];
    if (users && users.length > 0) {
      result = users.filter(resultItem => {
        // Filter from already shared collaborators(props)
        const matchWithAlreadyShared = this.props.collaborators.find(
          collaborator => collaborator.user.id === resultItem.id,
        );
        // Filter from currently added collaborator list(state)
        const matchWithToBeShared = this.state.shareWith.find(
          shareWithItem => shareWithItem.id === resultItem.id,
        );
        // Filter from current user
        const resultItemIsLoggedIn =
          readDataFromLocalStorage("revvsalesUser") &&
          readDataFromLocalStorage("revvsalesUser").id === resultItem.id;

        let itemOwnerValue = null;
        if (this.props.assetItem) {
          itemOwnerValue = this.props.assetItem.itemOwner;
        }
        // Filter from item owner
        const resultItemIsOwner =
          itemOwnerValue && itemOwnerValue.id === resultItem.id;
        if (
          matchWithAlreadyShared ||
          matchWithToBeShared ||
          resultItemIsLoggedIn ||
          resultItemIsOwner
        ) {
          return false;
        }
        return true;
      });
    }
    return result;
  };

  _inviteCollaborators = () => {
    const data = this.state.shareWith.map(item => ({
      user: { id: item.id },
      access_level: item.currentAccess ? item.currentAccess.toUpperCase() : "",
    }));
    const { assetItem } = this.props;
    const payload = {
      assetItemId: assetItem ? assetItem.folderId : null,
      data,
    };
    this.props
      .assetAddCollaborators(payload, "ADD")
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: `${
            assetItem ? assetItem.folderName : ""
          } has been shared successfully.`,
          timeout: 2000,
        });
        this.setState({ shareWith: [], showSelector: true });
      })
      .catch(error => {
        console.error(
          `AssetCollaboratorPopup => _addCollaborators => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Something went wrong. Please try again!",
          timeout: 3000,
        });
      });
  };

  render() {
    const { shareWith, showSelector, showBtnLoader } = this.state;
    const getOptions = debounce(this._getOptions, DEBOUNCE_WAIT_TIME);
    return (
      <Fragment>
        <div className="assetinvitesection-container">
          <div className="assetcollaboratorpopup-form-title">
            Add teammates already in your Revv org{" "}
          </div>
          {/* ---------------- Add User to Users List Section ---------------- */}
          {showSelector && (
            <div className="assetinvitesection-form-row">
              <SearchableSelect
                getOptionLabel={({ name }) => name}
                promiseOption={getOptions}
                value={this.props.ownerFilters}
                _handleChangeInSelect={this._handleChangeInSelect}
                placeholder="Type user's name..."
              />
              <div className="assetinvitesection-selectinput-wrapper select-input">
                <ReactSelect
                  onChange={value => this._updateShareAccess(value.value)}
                  options={accessLevels}
                  value={
                    (shareWith.length > 0 &&
                      shareWith[shareWith.length - 1].currentAccess) ||
                    "View"
                  }
                  data-test="assetsinvitesection-accesslevels-select"
                />
                <span className="btn-icon assetinvitesection-deleteicon-wrapper">
                  <span
                    className="btn-icon assetinvitesection-delete-icon"
                    onClick={() => this._removeSelectedUser(null)}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0">
                    <FontAwesomeIcon icon={["far", "trash-alt"]} />
                  </span>
                </span>
              </div>
            </div>
          )}

          {/* ---------------- Added Users To List Section ----------------  */}
          {shareWith.map(people => (
            <div className="assetinvitesection-form-row">
              <span className="assetinvitesection-username-box">
                {people.name}
              </span>
              <span className="assetinvitesection-selectinput-wrapper selected-input">
                <ReactSelect
                  onChange={value =>
                    this._updateShareAccess(people.name, value.value)
                  }
                  options={accessLevels}
                  value={people.currentAccess}
                  valueKey="currentAccess"
                  labelKey="label"
                  data-test="assetinvitesection-added-users-select"
                />
                <span className="btn-icon assetinvitesection-deleteicon-wrapper">
                  <span
                    className="btn-icon assetinvitesection-delete-icon"
                    onClick={() => this._removeSelectedUser(people.id)}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0">
                    <FontAwesomeIcon icon={["far", "trash-alt"]} />
                  </span>
                </span>
              </span>
            </div>
          ))}

          {/* ---------- Add More User Section ---------- */}
          <div className="assetinvitesection-addbtn-wrapper">
            <span
              className={`revv-btn revv-btn-secondary-sm assetinvitesection-add-btn ${
                showSelector ? "disable-add-btn" : ""
              }`}
              onClick={
                !showSelector
                  ? () => this.setState({ showSelector: true })
                  : () => {}
              }
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <i>
                <FontAwesomeIcon icon={["far", "plus"]} />
              </i>
              Add Another User
            </span>
          </div>

          {/* ---------------- Invite Section ----------------  */}
          {shareWith.length > 0 && (
            <div className="assetinvitesection-invitebtn-wrapper">
              <Button
                className="btn btn-primary invitebtn"
                isLoading={showBtnLoader}
                onClick={this._inviteCollaborators}
                data-test="assetinvitesection-invite-btn">
                INVITE
              </Button>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}
const mapDispatchToProps = {
  assetAddCollaborators: assetCollaboratorsAccessAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(AssetInviteSection);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetCollaboratorPopup/AssetInviteSection/index.js